import React, { useState, useEffect, useRef } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import StudentInfo from "./StudentInfo";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";

/** Prefer challan header from API; otherwise first ledger line with a non-empty type. */
function getChallanReferenceIdType(item) {
  const hdr = item?.Reference_ID_Type;
  if (hdr != null && String(hdr).trim() !== "") return String(hdr).trim();
  const ledger = item?.ReducedADLedger;
  if (!Array.isArray(ledger) || ledger.length === 0) return "";
  const row = ledger.find(
    (l) => l?.Reference_ID_Type != null && String(l.Reference_ID_Type).trim() !== ""
  );
  return row ? String(row.Reference_ID_Type).trim() : "";
}

function PrintChallan(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [voucheres, setVouchers] = useState([]);
  const [SchoolName, setSchoolName] = useState("");
  const [SchoolLogo, setSchoolLogo] = useState("");
  const [SchoolAddress, setSchoolAddress] = useState("");
  const [SchoolPhone, setSchoolPhone] = useState("");

  const location = useLocation();
  const [bank, setBank] = useState("");
  const pdfContentRef = useRef(null);
  const [autoPdfStarted, setAutoPdfStarted] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const isPublicMode =
    urlParams.get("public") === "1" ||
    window.location.pathname.toLowerCase().includes("/students/publicchallandownload");

  const downloadPdf = () => {
    const element = pdfContentRef.current;

    if (!element) return;

    const opt = {
      margin: [0, 1, 0, 1], // top, right, bottom, left
      filename: `${voucheres[0]?.Challan_No || "challan"}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 1.2,         // 🔥 improves quality
        useCORS: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "landscape",
      },

      pagebreak: {
        mode: ["avoid-all", "css"]
      }

    };

    html2pdf().set(opt).from(element).save();
  };

  useEffect(() => {
    document.title = "Print Voucher";
    const fetchVouchers = async () => {
      setLoading(true);
      const publicMode = isPublicMode;

      const classId = urlParams.get("Class_Id");
      const wingId = urlParams.get("Wing_Id");
      const concessionRuleId = urlParams.get("ConcessionRuleID");
      const orderBy = urlParams.get("OrderBy");
      const registrationNo = urlParams.get("Registration_No");
      const sectionId = urlParams.get("Section_Id");
      const SessionId = urlParams.get("SessionID");
      const Description = urlParams.get("Description");
      const valuesSelected = urlParams.get("valuesSelected") || "";
      const challanNos = urlParams.get("ChallanNos") || "";
      const selectionKey = urlParams.get("SelectionKey") || ""; 
      const publicChallanNo = (urlParams.get("challanNo") || "").trim();
      const AdvanceMonths = urlParams.get("AdvanceMonths");
      const ShowHolidayImage = urlParams.get("ShowHolidayImage");
      const noRedCresent = urlParams.get("noRedCresent");
      const Amount = urlParams.get("amount");
      const Student_ID = urlParams.get("Student_ID");
      const StudentType = urlParams.get("StudentType");
      const showPreviousFee = urlParams.get("showPreviousFee");
      const feeCodes = urlParams.get("feeCodes") || "";
      const selectedMonth = urlParams.get("SelectedMonth");
      const fYear = urlParams.get("FYear");
      const paidStatusFilter = urlParams.get("PaidStatusFilter");
      const referenceIdType = urlParams.get("Reference_ID_Type");
      const latestChallan = urlParams.get("latestChallan") === "1";

      const selectedArray = valuesSelected != "" ? valuesSelected.split(',').map(Number) : [];
      // NOTE: Some IIS setups block comma-separated querystrings and return 403.
      // Accept multiple delimiters and keep frontend free to choose a safe one (we use "~").
      let selectedChallanNos = challanNos
        ? challanNos
          .split(/[,\s~|;]+/g)
          .map((val) => val.trim())
          .filter(Boolean)
        : [];

      if (selectedChallanNos.length === 0 && selectionKey) {
        try {
          const raw = localStorage.getItem(selectionKey);
          if (raw) {
            const parsed = JSON.parse(raw);
            const saved = Array.isArray(parsed)
              ? parsed
              : Array.isArray(parsed?.challanNos)
                ? parsed.challanNos
                : [];
            selectedChallanNos = saved
              .map((val) => String(val || "").trim())
              .filter(Boolean);
          }
        } catch (e) {
          // Keep selectedChallanNos empty and continue with filter-based flow.
        }
      }

      const selectedFeeCodes = feeCodes != "" ? feeCodes.split(',').map(code => String(code.trim())) : [];

      if (latestChallan && selectedChallanNos.length === 0 && Student_ID) {
        try {
          const latestResp = await axios({
            method: "post",
            url: config.base_url + "ADLedger/GetLatestChallanByStudent",
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              AccessKey: AccessKey,
              UserID: UserID,
              MemberType: MemberType,
              Student_ID: Student_ID,
              Registration_No: registrationNo,
            },
          });

          if (latestResp.data && latestResp.data.status_code == 1 && latestResp.data.Challan_No) {
            selectedChallanNos = [latestResp.data.Challan_No];
          }
        } catch (error) {
          ////console.log(error);
        }
      }

      if (
        selectedChallanNos.length === 0 &&
        (wingId || classId || sectionId || selectedMonth || fYear || paidStatusFilter || referenceIdType)
      ) {
        try {
          const headResp = await axios({
            method: "post",
            url: config.base_url + "MonthlyTask/GetChalanHeads",
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              AccessKey: AccessKey,
              UserID: UserID,
              MemberType: MemberType,
              pageNo: 1,
              pageSize: 100000,
              SessionID: SessionId,
              Wing_Id: wingId || 0,
              Class_Id: classId || 0,
              Section_Id: sectionId || 0,
              SelectedMonth: selectedMonth || 0,
              FYear: fYear || 0,
              PaidStatusFilter: paidStatusFilter || 0,
              Reference_ID_Type: referenceIdType || undefined,
            },
          });
          if (
            headResp.data &&
            headResp.data.status_code === 1 &&
            Array.isArray(headResp.data.ListofRecords)
          ) {
            selectedChallanNos = headResp.data.ListofRecords
              .map((row) => row.Challan_No)
              .filter(Boolean);
          }
        } catch (error) {
          ////console.log(error);
        }
      }

      if (publicMode) {
        const targetChallanNo =
          publicChallanNo ||
          (selectedChallanNos.length > 0 ? selectedChallanNos[0] : "");
        if (!targetChallanNo) {
          setLoading(false);
          return;
        }

        try {
          const publicResp = await axios.get(
            `${config.base_url}ADLedger/PublicChallanPrint`,
            { params: { challanNo: targetChallanNo } }
          );
          if (
            publicResp.data &&
            publicResp.data.status_code === 1 &&
            Array.isArray(publicResp.data.ListofRecords)
          ) {
            setVouchers(publicResp.data.ListofRecords || []);
            setSchoolName(publicResp.data.SchoolName || "");
            if (publicResp.data.SchoolLogo) {
              const logoPath = publicResp.data.SchoolLogo.replace(/^\/+/, "");
              setSchoolLogo(config.root + logoPath);
            }
            setSchoolAddress(publicResp.data.SchoolAddress || "");
            setSchoolPhone(publicResp.data.SchoolPhone || "");
            setBank(publicResp.data.FeeVoucherStatement || "");
          }
        } catch (error) {
          ////console.log(error);
        } finally {
          setLoading(false);
        }
        return;
      }

      const data = selectedChallanNos.length > 0
        ? {
          AccessKey: AccessKey,
          UserID: UserID,
          MemberType: MemberType,
          Challan_Nos: selectedChallanNos,
          FeeCodes: selectedFeeCodes,
        }
        : {
          AccessKey: AccessKey,
          UserID: UserID,
          MemberType: MemberType,
          SelectedStudents: selectedArray,
          SessionID: SessionId,
          Class_Id: classId,
          Section_Id: sectionId,
          Wing_Id: wingId,
          ConcessionRuleID: concessionRuleId,
          Registration_No: registrationNo,
          SelectedMonth: selectedMonth,
          FYear: fYear,
          AdvanceMonths: AdvanceMonths,
          ShowHolidayImage: ShowHolidayImage,
          noRedCresent: noRedCresent,
          Description: Description,
          OrderBy: orderBy,
          Amount: Amount,
          Student_ID: Student_ID,
          StudentType: StudentType,
          AddTransportFee: showPreviousFee,
          SeletedClassNames: selectedFeeCodes,
        };

      const api_config = {
        method: "post",
        url:
          config.base_url +
          (selectedChallanNos.length > 0
            ? "ADLedger/PrintVouchersByChallanNos"
            : "ADLedger/PrintVouchersWithAD"),
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      try {
        const response = await axios(api_config);
        if (response.data.status_code == 1) {
          setVouchers(response.data.ListofRecords);
          setSchoolName(response.data.SchoolName);
          if (response.data.SchoolLogo) {
            const logoPath = response.data.SchoolLogo.replace(/^\/+/, "");
            setSchoolLogo(config.root + logoPath);
          }
          setSchoolAddress(response.data.SchoolAddress || "");
          setSchoolPhone(response.data.SchoolPhone || "");
          setBank(response.data.FeeVoucherStatement);
        }
      } catch (error) {
        ////console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchVouchers();
  }, [isPublicMode]);

  useEffect(() => {
    if (isPublicMode && !loading && voucheres.length > 0 && !autoPdfStarted) {
      setAutoPdfStarted(true);
      setTimeout(() => {
        downloadPdf();
      }, 300);
    }
  }, [isPublicMode, loading, voucheres, autoPdfStarted]);


  const copyLabels = ["Bank Copy", "Office Copy", "Student Copy"];
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner animation="border" role="status"></Spinner>
      </div>
    );
  } else if (voucheres.length > 0) {
    return (
      <>
        <button className="button button-primary download-pdf-button" onClick={downloadPdf}>
          Download PDF
        </button>
        <div ref={pdfContentRef}
          className="pdf-wrap"

          style={{
            backgroundColor: "#FFF",
          }}

        >
          {voucheres.map((item, index) => {
            //console.log("my", item);
            //console.log("bank", item.addBankCopy);
            const hasLedger = item.ReducedADLedger && item.ReducedADLedger.length > 0;
            const kuickpayId = item.Student_ID ? `15470${item.Student_ID}` : "";
            const referenceIdType = getChallanReferenceIdType(item);
            return (
              <div key={index}>
                <div
                  // style={{
                  //   backgroundColor: "#FFF",
                  //   color: "#000",
                  //   width: "100%",
                  //   fontSize: "11px",
                  //   display: "flex",
                  //   justifyContent: "center",
                  // }}


                  align="right"
                >
                  <div
                    style={{
                      // width: "297mm",
                      // minHeight: "210mm",
                      // lineHeight: "18px",
                      // marginTop: 0, // ❌ remove 2mm
                      // boxSizing: "border-box",
                      // pageBreakInside: "avoid",
                      // breakInside: "avoid-page",
                      // pageBreakAfter: index < voucheres.length - 1 ? "always" : "auto",
                      // breakAfter: index < voucheres.length - 1 ? "page" : "auto",
                    }}
                    className="page a4 landscape print-voucher page-break "
                  >
                    <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
                      <tbody>
                        <tr>
                          <td style={{ width: "33%" }} valign="top" align="left">
                            <StudentInfo
                              school={SchoolName}
                              schoolAddress={SchoolAddress}
                              schoolPhone={SchoolPhone}
                              logo={SchoolLogo}
                              studentcode={
                                item.Registration_No == ""
                                  ? item.Student_ID + " (New Registration)"
                                  : item.Registration_No
                              }
                              admissionNo={item.Registration_No}
                              className={item.Class_Name}
                              section={item.Section_Name}
                              name={item.Student_Name}
                              wing={item.Wing_Name}
                              father={item.Father_Name}
                              bank={bank}
                              copy={copyLabels[0]}
                              fee={item.ReducedADLedger || []}
                              dueDate={item.Challan_DueDate}
                              issueDate={item.Date_Of_Joining}
                              monthDate={
                                hasLedger
                                  ? item.ReducedADLedger[0].PostingDate
                                  : item.Date_Of_Joining
                              }
                              kuickpayId={kuickpayId}
                              challanNo={item.Challan_No}
                              Reference_ID_Type={referenceIdType}
                              Remarks={item.Remarks}
                            />
                            {!hasLedger && (
                              <div style={{ fontSize: "11px", padding: "6px 0", color: "#a00" }}>
                                No fee details found for this challan.
                              </div>
                            )}
                          </td>
                          <td
                            style={{
                              width: "6mm",
                              borderLeft: "2px dashed black",
                            }}
                          ></td>
                          <td style={{ width: "33%" }} valign="top" align="left">
                            <StudentInfo
                              school={SchoolName}
                              schoolAddress={SchoolAddress}
                              schoolPhone={SchoolPhone}
                              logo={SchoolLogo}
                              studentcode={
                                item.Registration_No == ""
                                  ? item.Student_ID + " (New Registration)"
                                  : item.Registration_No
                              }
                              admissionNo={item.Registration_No}
                              className={item.Class_Name}
                              section={item.Section_Name}
                              name={item.Student_Name}
                              wing={item.Wing_Name}
                              father={item.Father_Name}
                              bank={bank}
                              copy={copyLabels[1]}
                              fee={item.ReducedADLedger || []}
                              dueDate={item.Challan_DueDate}
                              issueDate={item.Date_Of_Joining}
                              monthDate={
                                hasLedger
                                  ? item.ReducedADLedger[0].PostingDate
                                  : item.Date_Of_Joining
                              }
                              kuickpayId={kuickpayId}
                              challanNo={item.Challan_No}
                              Reference_ID_Type={referenceIdType}
                              Remarks={item.Remarks}
                            />
                          </td>
                          <td
                            style={{
                              width: "6mm",
                              borderLeft: "2px dashed black",
                            }}
                          ></td>
                          <td style={{ width: "33%" }} valign="top" align="left">
                            <StudentInfo
                              school={SchoolName}
                              schoolAddress={SchoolAddress}
                              schoolPhone={SchoolPhone}
                              logo={SchoolLogo}
                              studentcode={
                                item.Registration_No == ""
                                  ? item.Student_ID + " (New Registration)"
                                  : item.Registration_No
                              }
                              admissionNo={item.Registration_No}
                              className={item.Class_Name}
                              section={item.Section_Name}
                              name={item.Student_Name}
                              wing={item.Wing_Name}
                              father={item.Father_Name}
                              bank={bank}
                              copy={copyLabels[2]}
                              fee={item.ReducedADLedger || []}
                              dueDate={item.Challan_DueDate}
                              issueDate={item.Date_Of_Joining}
                              monthDate={
                                hasLedger
                                  ? item.ReducedADLedger[0].PostingDate
                                  : item.Date_Of_Joining
                              }
                              kuickpayId={kuickpayId}
                              challanNo={item.Challan_No}
                              Reference_ID_Type={referenceIdType}
                              Remarks={item.Remarks}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }
}

export default PrintChallan;
